import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';

import { useAuthUser } from '@/providers/auth/auth-user-provider';

/**
 * Use LaunchDarkly Context
 * Sets the LaunchDarkly context for the current user, organization, facility, and agent
 */
export const useLaunchDarklyContext = () => {
  const { user } = useAuthUser();
  const userId = user?.id;
  const ldClient = useLDClient();

  // Set LaunchDarkly context
  useEffect(() => {
    if (!ldClient) {
      console.log('LaunchDarkly client not initialized');
      return;
    }
    const ldContext: any = { kind: 'multi' };
    let setContext = false;
    if (userId) {
      console.log('Setting LaunchDarkly context with user ID:', userId);
      ldContext.user = { key: userId };
      setContext = true;
    } else {
      console.log('No user ID available for LaunchDarkly context');
    }
    if (setContext) {
      ldClient.identify(ldContext);
    }
  }, [userId, ldClient]);
};
